import api from './client';

export type InverterCurrent = {
  inverter_id: number;
  inverter_uuid_id: string;
  inverter_name: string;
  inverter_serial_number: string;
  inverter_brand: string;
  inverter_model: string;
  inverter_capacity_kwp: string | null;
  inverter_power_plant_name: string;
  inverter_string_count: number | null;
  inverter_active_power: number | null;
  inverter_voltage_line_ab: number | null;
  inverter_voltage_line_bc: number | null;
  inverter_voltage_line_ca: number | null;
  inverter_current_phase_a: number | null;
  inverter_current_phase_b: number | null;
  inverter_current_phase_c: number | null;
  inverter_power_factor: number | null;
  inverter_reactive_power: number | null;
  inverter_grid_frequency: number | null;
  inverter_internal_temperature: number | null;
  inverter_e_day: string | null;
  inverter_e_day_kwh?: number | null;
  inverter_e_total: string | null;
  inverter_ftp_connection_status: 0 | 1;
  inverter_modbus_connection_status: 0 | 1;
  inverter_ftp_status_code: number | null;
  inverter_modbus_status_code: number | null;
  inverter_last_seen: string | null;
  inverter_status: 0 | 1;
};

export type InverterString = {
  string_number: number;
  string_current_ftp: number | null;
  string_voltage_ftp: number | null;
  string_current_modbus: number | null;
  string_voltage_modbus: number | null;
  string_efficiency: number | null;
};

export type PowerPoint = {
  date_name: string;
  power_total: string | number;
  date_year?: number;
  date_month?: number;
  date_day?: number;
  date_hour?: number;
};

export type InverterDetail = {
  current: InverterCurrent;
  strings: InverterString[];
  hourly: PowerPoint[];
  daily: PowerPoint[];
  monthly: PowerPoint[];
  yearly: PowerPoint[];
};

/** `view: 'flow'` returns only `current` and `strings`; the chart arrays come back empty. */
export async function fetchInverterDetail(id: number, options: { view?: 'flow' } = {}): Promise<InverterDetail> {
  const res = await api.get<InverterDetail>(`/inverters/${id}`, { params: options.view ? { view: options.view } : undefined });
  return res.data;
}

export async function fetchInverterDrillChart(
  inverterId: number,
  year: number,
  month: number | null,
  day: number | null,
): Promise<PowerPoint[]> {
  const params: Record<string, string> = { year: String(year) };
  if (month !== null) params.month = String(month);
  if (day !== null) params.day = String(day);
  const res = await api.get<{ data: PowerPoint[] }>(`/inverters/${inverterId}/power-chart/drill`, { params });
  return res.data.data;
}
